/**
 * mc library
 */

import * as THREE from "three";

export default (function(scene, radius) {

    var SEGMENTS = 180; // number of vertices. Higher = better mouse accuracy, slower loading
    var TRANSPARENT_BLACK = [0, 0, 0, 0];     // singleton 0 rgba
    var OVERLAY_ALPHA = Math.floor(0.5*255);  // overlay transparency (on scale [0, 255])

    var overlayGeometry;
    var overlayMaterial, overlayMesh, overlayTexture, overlayTextureData;
    const overlayMeshName = "worldOverlayMesh";


    function makeOverlayTexture(grids) {
        let overlayGrid = grids.overlayGrid;
        let header = overlayGrid.header;
        let nx = header.nx;
        let ny = header.ny;
        let size = nx * ny;
        overlayTextureData = new Uint8Array( 4 * size );
        let data = new Uint8Array( 4 * size );

        for (let i = 0; i < 4 * size; i ++ ) {
            data[i * 4] = 0.;
            data[i * 4 + 1] = 0.;
            data[i * 4 + 2] = 0.;
            data[i * 4 + 3] = 0.;
        }

        overlayTextureData.set(data);
        overlayTexture = new THREE.DataTexture(overlayTextureData, nx, ny, THREE.RGBAFormat);
        overlayTexture.minFilter = THREE.LinearFilter;
        overlayTexture.magFilter = THREE.LinearFilter;
        overlayTexture.flipY = true;
        overlayTexture.onUpdate = function(){
            data = null;
        }
        overlayTexture.needsUpdate = true;
    }

    // function drawVert(){
    //     return `
    //         varying vec2 v_texCoord;
    //
    //         void main() {
    //             v_texCoord = uv;
    //             gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    //         }
    //     `;
    // }
    //
    // function drawFrag(){
    //     return `
    //         precision mediump float;
    //
    //         uniform sampler2D u_texture;
    //         uniform float u_opacity;
    //         uniform float u_time_zone;
    //
    //         varying vec2 v_texCoord;
    //
    //         void main() {
    //             vec4 color = texture2D(u_texture, vec2(mod(v_texCoord.x + u_time_zone, 1.0), v_texCoord.y));
    //             gl_FragColor = vec4(color.xyz, u_opacity);
    //         }
    //     `;
    // }

    function meshOverlayMaterial(grids, quickRender) {
        // let overlayGrid = grids.overlayGrid;
        // let header = overlayGrid.header;
        // let dx = Math.abs(header.dx);
        // let lo1 = header.lo1;
        // let rotate = parseInt(lo1) === 0 ? 180. + dx / 2. : parseFloat(lo1);
        overlayGeometry = new THREE.SphereBufferGeometry(radius, SEGMENTS, SEGMENTS);
        overlayMaterial = new THREE.MeshBasicMaterial({transparent: true, opacity: 1.0});
        // overlayMaterial = new THREE.ShaderMaterial( {
        //     transparent: true,
        //     wireframe: false,
        //     opacity: 0.7,
        //     uniforms: {
        //         u_time_zone: {value: (parseInt(lo1) + Math.floor(rotate)) / 360},
        //         u_texture: {type:"t", value: overlayTexture},
        //         u_opacity: {value: 0.7}
        //     },
        //     vertexShader: drawVert(),
        //     fragmentShader: drawFrag(),
        // });
        overlayMaterial.map = overlayTexture;
        overlayMesh = new THREE.Mesh(overlayGeometry, overlayMaterial);
        overlayMesh.name = overlayMeshName;
        scene.add(overlayMesh);


    }

    // function calculateOverlayValues(forEachPoint, nx){
    //     let values = [], ii = 0, ix = 0;
    //
    //     forEachPoint(function(λ, φ, d) {
    //         // if (µ.isValue(d) && ix%(nx+1) !== nx) {
    //             values[ii++] = d;
    //             // console.log(λ, φ, d);
    //         // }
    //         // ix++;
    //     });
    //
    //     return values;
    // }

    function updateOverlayTexture(grids, quickRender) {
        if(!overlayTextureData || !overlayTexture) return;

        let primaryGrid = grids.primaryGrid;
        let overlayGrid = grids.overlayGrid;
        let hasDistinctOverlay = primaryGrid !== overlayGrid;
        let header = overlayGrid.header;
        let scale = hasDistinctOverlay ? overlayGrid.scale : primaryGrid.scale;
        let nx = header.nx;
        let ny = header.ny;
        let dx = header.dx;
        let dy = header.dy;
        let wind = null, scalar = null, ix = null, iy = null;
        let color = TRANSPARENT_BLACK;
        let size = nx * ny;
        let data = new Uint8Array(4 * size);

        let interpolate = hasDistinctOverlay ? overlayGrid.interpolate
            : primaryGrid.interpolate;

        for (let j = 0; j < ny; j++) {
            for (let i = 0; i < nx; i++) {
                ix = i;
                iy = j; // have to set texture.filpY = true for uv coords;

                if(hasDistinctOverlay){ //스칼라 변수일때
                    var λ = ix*dx + 180, φ = 90 - iy*dy;
                    if (λ > 360) λ = λ - 360;
                    scalar = interpolate(λ, φ);
                    if (header.parameterNumberName === "Od550aer") {
                        //미세먼지는 수치에 따라 투명도 가중치를 적용한다.
                        let ratio = 1;
                        if (scalar < 0.3) ratio = 0.5;
                        else ratio = 2;

                        const alpah = scalar * ratio * OVERLAY_ALPHA > 210 ? 210 : scalar * 1.5 * OVERLAY_ALPHA;
                        if (scalar === null) color = TRANSPARENT_BLACK;
                        else color = scale.gradient(scalar, alpah);
                    } else if (header.parameterNumberName === "salnt") {
                        if (scalar === null) color = TRANSPARENT_BLACK;
                        else color = scale.gradient(scalar, OVERLAY_ALPHA);
                    } else {
                        if (scalar === null) color = TRANSPARENT_BLACK;
                        else color = scale.gradient(scalar, OVERLAY_ALPHA);
                    }
                } else { //벡터 변수일때
                    var λ = ix*dx + 180, φ = 90 - iy*dy;
                    if (λ > 360) λ = λ - 360;
                    // if (φ === 90 || φ === -90) continue;
                    wind = interpolate(λ, φ);
                    if (wind === null) wind = [0,0,0];
                    scalar = Math.sqrt(wind[0] * wind[0] + wind[1] * wind[1]);
                    color = scale.gradient(scalar, OVERLAY_ALPHA);
                }

                if(scale.customBounds.length > 0 && (scale.customBounds[0] !== "" || scale.customBounds[1] !== "")){
                    if(scale.customBounds[0] !== "" && scale.customBounds[1] !== ""){
                        if(scalar < scale.customBounds[0] || scalar > scale.customBounds[1]){
                            color = TRANSPARENT_BLACK;
                        }
                    }else if(scale.customBounds[0] !== ""){
                        if(scalar < scale.customBounds[0]){
                            color = TRANSPARENT_BLACK;
                        }
                    }else{
                        if(scalar > scale.customBounds[1]){
                            color = TRANSPARENT_BLACK;
                        }
                    }
                }

                data[(i + j * nx) * 4] = color[0];
                data[(i + j * nx) * 4 + 1] = color[1];
                data[(i + j * nx) * 4 + 2] = color[2];
                data[(i + j * nx) * 4 + 3] = color[3];
            }
        }
        overlayTextureData.set(data);
        overlayTexture.onUpdate = function(){
            data = null;
            // values = null;
        }
        overlayTexture.needsUpdate = true;
        quickRender();
    }


    function clear(){
        if(overlayTexture) overlayTexture.dispose();
        if(overlayGeometry) overlayGeometry.dispose();
        if(overlayMaterial) {
            overlayMaterial.map.dispose();
            overlayMaterial.dispose();
        }

        if(overlayMesh) scene.remove(scene.getObjectByName(overlayMeshName));

        overlayTexture = undefined;
        overlayGeometry = undefined;
        overlayMaterial = undefined;
        overlayMesh = undefined;
        overlayTextureData = undefined;
    }

    function moveOverlay(rotate, scale) {
        if(overlayMesh) {
            // roate
            var twoPI = Math.PI * 2;
            var halfPI = Math.PI / 2;
            overlayMesh.rotation.y = Math.PI + halfPI + (rotate[0] / 360 * twoPI) + (-0.35 * Math.PI / 180);
            overlayMesh.rotation.x = -rotate[1] / 90 * Math.PI / 2;
            overlayMesh.rotation.z = rotate[2] / 360 * twoPI;

            // zoom
            overlayMesh.scale.set(scale, scale, scale);
        }
    }

    return {
        render: function render(grids, quickRender){

            let overlayGrid = grids.overlayGrid;
            let header = overlayGrid.header;
            if(header === "") {
                clear();
                quickRender();
                return;
            };

            clear();
            makeOverlayTexture(grids);
            meshOverlayMaterial(grids, quickRender);
            updateOverlayTexture(grids, quickRender);
        },
        clear: clear,
        moveOverlay
    };
});
